import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "./AuthLayout";
import API from "../lib/api";
import { useT, localizeError } from "../components/home/i18n";

export default function ResetPassword() {
  const { t } = useT();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const c = t.auth.reset;

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error(c.minLen);
    if (password !== confirm) return toast.error(c.mismatch);
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, password });
      toast.success(c.updated);
      navigate("/login");
    } catch (err) {
      toast.error(localizeError(err.response?.data?.detail, t));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout testid="reset-password-page" title={c.noTokenTitle} subtitle={c.noTokenSub}>
        <div data-testid="reset-no-token" className="space-y-4 text-sm text-[#2C2A29]">
          <p className="rounded-sm border border-[#E8E4DB] bg-[#FDFBF7] px-4 py-3">{c.noTokenPanel}</p>
          <Link to="/forgot-password" data-testid="request-new-link" className="block text-center font-semibold text-[#1F4A38]">{c.requestNew}</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout testid="reset-password-page" title={c.title} subtitle={c.subtitle}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-medium text-[#5C5855]">{c.newPw}</label>
          <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]" />
        </div>
        <div>
          <label className="text-xs font-medium text-[#5C5855]">{c.confirmPw}</label>
          <input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
            className="mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]" />
        </div>
        <button data-testid="reset-submit" disabled={loading}
          className="w-full rounded-full bg-[#1F4A38] py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
          {loading ? c.submitting : c.submit}
        </button>
        <p className="text-center text-sm text-[#5C5855]">
          <Link to="/login" data-testid="go-login" className="font-semibold text-[#1F4A38]">{c.back}</Link>
        </p>
      </form>
    </AuthLayout>
  );
}
